import { Controller } from "@hotwired/stimulus";

export default class extends Controller {

    static targets = [ "sectionType", "staticContentField", "generationContextField" ]

    connect() {
        this.toggle();
    }

    toggle() {
        const isStatic = this.sectionTypeTarget.value === "static";
        this.staticContentFieldTarget.style.display = isStatic ? "block" : "none";
        if (this.hasGenerationContextFieldTarget) {
            this.generationContextFieldTarget.style.display = isStatic ? "none" : "block";
        }
    }

}
